import React, { lazy, Suspense, useEffect } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import Unregistered from "./modules/Unregistered/Index";
import PublicDocumentControl from "./pages/public/DocumentControl"
import Login from "./modules/Authentication/Login";
import useCommonIntl from "./hooks/useCommonIntl";
import SignIn from "./modules/SignIn/SignIn";
const StakeholderCabinet = lazy(() => import("./modules/StakeholderCabinet/Index"));

export function Routes() {
    useCommonIntl();
    const isAutorized = useSelector(state => state.loginForTestEnv.isAutorized);
    const { currentStakeholder } = useSelector(state => state.stakeholder);

    let routes = (
        <Switch>
            <Route path="/" exact component={Login} />
            <Route path="/public/document/:id" component={PublicDocumentControl} />
            <Redirect to="/" />
        </Switch>
    );

    if (!isAutorized && process.env.REACT_APP_ENV === "test") {
        routes = (
            <Switch>
                <Route path="/signin" >
                    <SignIn />
                </Route>
                <Redirect path="*" to="/signin" />
            </Switch>
        )
    } else if (currentStakeholder && currentStakeholder.active) {
        routes = (
            <Switch>
                <Route path="/" exact component={Login} />
                <Route path="/stakeholder/cabinet" ><StakeholderCabinet /></Route>
                <Route path="/public/document/:id" component={PublicDocumentControl} />
                <Redirect path="*" to="/stakeholder/cabinet" />
            </Switch>
        );
    } else if (currentStakeholder && !currentStakeholder.active) {
        routes = (
            <Switch>
                <Route path="/" exact component={Login} />
                <Route path="/stakeholder/new" component={Unregistered} />
                <Route path="/public/document/:id" component={PublicDocumentControl} />
                <Redirect path="*" to="/stakeholder/new" />
            </Switch>
        );
    }

    return routes;
}
